export const parsePaymentAmount = value => {
	const normalized = String(value).trim().replace(',', '.');
	return /^\d+(?:\.\d+)?$/.test(normalized) ? Number(normalized) : NaN;
};

export const roundMoney = value => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const amountByPercent = (balance, percent) => roundMoney(Number(balance) * Number(percent) / 100);

export const convertAmount = (amount, rate) => roundMoney(Number(amount) * Number(rate));
